import React from 'react';
import { iconSize } from '../../../../constants/icon.constants';
import fields from '../../../../constants/fields.const';
import { SocialMediaModel } from './models/index.model';
import { TSocialMediaProps } from './types/index.types';
import { googleSocialEvent } from '../../../../utils/analytics';
import Icon from '../../../@shared/icon';
import { EditFrameComponent } from '../../../@shared/editFrame';
import CustomExternalAnchor from '../../../@shared/customExternalAnchor';

const SocialMedia = (props: TSocialMediaProps): JSX.Element => {
  const model = new SocialMediaModel(props);
  const isEEactive = props?.sitecoreContext?.pageEditing;

  return (
    <div className="social-media">
      {model.socialLinks?.map((item) => {
        return (
          <div className="social-media__social-icon-link-wrapper">
            {isEEactive ? (
              <>
                <CustomExternalAnchor
                  field={item?.fields?.link}
                  key={item?.id}
                  className={'social-media-section__social-icon-link'}
                  target="_blank"
                />
                <EditFrameComponent itemId={item.id} fields={[fields.icon]} sitecoreContext={props?.sitecoreContext as any}>
                  <Icon iconField={item?.fields?.icon} size={iconSize.mbl} color="primary" />
                </EditFrameComponent>
              </>
            ) : (
              <CustomExternalAnchor
                field={item?.fields?.link}
                key={item?.id}
                className={'social-media-section__social-icon-link'}
                target="_blank"
                onClick={() => googleSocialEvent(item?.displayName)}
              >
                <Icon iconField={item?.fields?.icon} size={iconSize.mbl} color="primary" />
              </CustomExternalAnchor>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SocialMedia;
